import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface SidebarMenu extends SVGProps<SVGSVGElement> {
  label?: string
}

const SidebarMenu: React.FC<SidebarMenu> = ({
  label = 'sidebarMenu',
  ...restProps
}) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="sidebar-menu-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 3.993C2.00183 3.73038 2.1069 3.47902 2.29251 3.29322C2.47813 3.10742 2.72938 3.00209 2.992 3H21.008C21.556 3 22 3.445 22 3.993V20.007C21.9982 20.2696 21.8931 20.521 21.7075 20.7068C21.5219 20.8926 21.2706 20.9979 21.008 21H2.992C2.72881 20.9997 2.4765 20.895 2.29049 20.7088C2.10448 20.5226 2 20.2702 2 20.007V3.993ZM12 5V19H20V5H12ZM13 7H19V9H13V7ZM13 10H19V12H13V10Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default SidebarMenu
